<div class="graph-container">
    <img [src]="graphImageUrl">

    <div class="graph-inner">
        <div [ngStyle]="employeeScoreStlye" title="{{ employeeUser?.NamePreferedLast}}">
            <figure class="ball employee-ball"><span class="shadow"></span></figure>
        </div>
        <div [ngStyle]="supervisorScoreStlye" title=" {{ supervisorUser?.NamePreferedLast}}">
            <figure class="ball supervisor-ball"><span class="shadow"></span></figure>
        </div>
    </div>
</div>

<div class="caption-container">
    <div class="caption-inner">
        <div class="caption-ball">
            <figure class="ball employee-ball"><span class="shadow"></span></figure>
        </div>
        <div class="caption">
            {{ employeeUser?.NamePreferedLast}}
        </div>
        <div class="caption-ball spacer">
            <figure class="ball supervisor-ball"><span class="shadow"></span></figure>
        </div>
        <div class="caption">
            {{ supervisorUser?.NamePreferedLast}}
        </div>
    </div>
</div>


<div *ngIf="showScoreDetails" class="score-details-container">
    <h2>Score Details</h2>

    <div dwRow>
        <div dwCol="12">
            <div class="caption-ball">
                <figure class="ball employee-ball"><span class="shadow"></span></figure>
            </div>
            <div class="caption">
                <h3>{{ employeeUser?.NamePreferedLast}}</h3>
            </div>
        </div>
    </div>
    <div dwRow>
        <div dwCol="1">

        </div>
        <div dwCol="11">
            <div dwRow>
                <div dwCol="6">
                    <label class="label">Soft Skill Average</label>
                </div>
                <div dwCol="6">
                    {{employeeReviewAnalysis?.employeeSkillAverage?.softSkillAverage | number: '1.0-1'}}
                </div>
            </div>
            <div dwRow>
                <div dwCol="6">
                    <label class="label">Hard Skill Average</label>
                </div>
                <div dwCol="6">
                    {{employeeReviewAnalysis?.employeeSkillAverage?.hardSkillAverage | number: '1.0-1'}}
                </div>
            </div>
            <div dwRow>
                <div dwCol="6">
                    <label class="label">Bubble Size</label>
                </div>
                <div dwCol="6">
                    {{employeeReviewAnalysis?.employeeSkillAverage?.bubbleSize | number: '1.0-1'}}
                </div>
            </div>
        </div>
    </div>
    <br>
    <div dwRow>
        <div dwCol="12">
            <div class="caption-ball">
                <figure class="ball supervisor-ball"><span class="shadow"></span></figure>
            </div>
            <div class="caption">
                <h3>{{ supervisorUser?.NamePreferedLast}}</h3>
            </div>
        </div>
    </div>
    <div dwRow>
        <div dwCol="1">

        </div>
        <div dwCol="11">
            <div dwRow>
                <div dwCol="6">
                    <label class="label">Soft Skill Average</label>
                </div>
                <div dwCol="6">
                    {{employeeReviewAnalysis?.supervisorSkillAverage?.softSkillAverage | number: '1.0-1'}}
                </div>
            </div>
            <div dwRow>
                <div dwCol="6">
                    <label class="label">Hard Skill Average</label>
                </div>
                <div dwCol="6">
                    {{employeeReviewAnalysis?.supervisorSkillAverage?.hardSkillAverage | number: '1.0-1'}}
                </div>
            </div>
            <div dwRow>
                <div dwCol="6">
                    <label class="label">Bubble Size</label>
                </div>
                <div dwCol="6">
                    {{employeeReviewAnalysis?.supervisorSkillAverage?.bubbleSize | number: '1.0-1'}}
                </div>
            </div>
        </div>
    </div>

</div>